<div class="card shadow">
  <div class="card-body">
    <div class="row align-items-center mb-4">
      <div class="col-auto ms-auto">
        <button
          id="addEmployeeButton"
          (click)="onAddEmployee()"
          class="btn btn-primary btn-sm">
          Add
        </button>
      </div>
    </div>

    <app-table
      [columns]="columns"
      [getDataCallback]="getData"
      class="table-invited-employees"
      emptyMessage="Your invited employees will appear here.">
      <ng-template
        #employeeNameCell
        let-row="row"
        let-value="value">
        <div class="row align-items-center flex-nowrap">
          <div class="col-auto pe-0">
            <app-avatar
              [firstName]="row.first_name"
              [lastName]="row.last_name"></app-avatar>
          </div>
          <div class="col ps-2">
            {{ value }}<br />
            @if (row.role.toLowerCase() === 'admin') {
              <div class="badge bg-dark">ADMIN</div>
            }
          </div>
        </div>
      </ng-template>

      <ng-template
        #dateCreatedCell
        let-value="value">
        {{ value | date: 'dd/MM/yy' }}
      </ng-template>

      <ng-template
        #frequencyCell
        let-value="value">
        @if (value === TopUpFrequency.Daily) {
          {{ TopUpFrequencyLabel.DAILY }}
        } @else if (value === TopUpFrequency.Weekly) {
          {{ TopUpFrequencyLabel.WEEKLY }}
        } @else if (value === TopUpFrequency.Monthly) {
          {{ TopUpFrequencyLabel.MONTHLY }}
        } @else {
          -
        }
      </ng-template>

      <ng-template
        #targetBalanceCell
        let-value="value">
        {{ value | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
      </ng-template>

      <ng-template
        #actionsCell
        let-row="row">
        <div class="row">
          <div class="col-auto">
            <button
              class="btn-action"
              [disabled]="disableResend[row.id]"
              (click)="resendEmployeeInvitation(row.id)"
              (keyup)="resendEmployeeInvitation(row.id)"
              title="Resend Invitation">
              <i class="pays-icon ic-mail-resend"></i>
            </button>
          </div>
          <div class="col-auto">
            <button
              (click)="onEditEmployee(row.id)"
              class="btn-action">
              <i class="iconoir-nav-arrow-right"></i>
            </button>
          </div>
        </div>
      </ng-template>
    </app-table>
  </div>
</div>

<div id="offCanvasGhostContainer">
  <router-outlet></router-outlet>
</div>
